const scrollToHashElement = () => {
    const hash = window.location.hash.substring(1);
    const element = document.getElementById(hash);
    if (element) {
        element.scrollIntoView({behavior: 'smooth'});
    }
}

export const ScrollUtil = {scrollToHashElement};
